// Packages
import { Fragment } from "react";

export const LoadingIcon = (props) => {
  const color = props.isInsideButton ? "#ffffff" : "#9FC300";
  const style = props.isInsideButton
    ? {
        color: color,
        width: "1.5rem",
        height: "1.5rem",
      }
    : {
        color: color,
      };

  return (
    <Fragment>
      {props.textInside ? (
        <div className="d-flex align-items-center ps-3 pe-3">
          <strong>{props.text}</strong>
          <div
            className="spinner-border ms-auto"
            role="status"
            style={style}
            aria-hidden="true"
          ></div>
        </div>
      ) : (
        <div
          className="d-flex justify-content-center"
          style={props.default ? { marginTop: "44vh" } : props.style}
        >
          <div className="spinner-border" role="status" style={style}>
            <span className="sr-only" />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default LoadingIcon;
